import styled from "styled-components";

export const ResultCardList = styled.ul`
  display: flex;
  overflow-y: auto;
  max-height: 200px;
  border-bottom: 1px solid ${(props) => props.theme.colors.border};
  flex-direction: column;
`;
